import workshop_rails from '../images/saas-giojuliao.png';
import sb from '../images/scrum-certificate-giojuliao.png';
import microverse from '../images/full-stack-certificate-giojuliao.png';
import israel from '../images/israel-giojuliao.png';
import railsMarketplace from '../images/marketplace-giojuliao.png';
import crossfitwod from '../images/fitness-app-giojuliao.png';
import linkedInAgent from '../images/personal-branding-giojuliao.png';
import emailScraper from '../images/map-scraper-giojuliao.png';
import legalAgent from '../images/legal_agent-giojuliao.png';
import investorAgent from '../images/investment-agent-giojuliao.png';
import hrAgent from '../images/human-resources-agent-giojuliao.png';
import realestate from '../images/realestate-agent-giojuliao.png';
import salesAgent from '../images/sales_agent.png';
import shoppingAgent from '../images/shopping-agent-giojuliao.png';
import shopifyAgent from '../images/shopify-agent-giojuliao.png';

export const ImagesContent = [
  {
    link: 'https://www.giojuliao.com/legal_agent',
    img: legalAgent,
    name: 'USA Legal Advisor AI Agent',
  },
  {
    link: 'https://www.giojuliao.com/google_maps_email_scraper',
    img: emailScraper,
    name: 'Google Maps Email Scraper AI Agent',
  },
  {
    link: 'https://www.giojuliao.com/personal_branding_agent',
    img: linkedInAgent,
    name: 'Linkedin Post Creator AI Agent',
  },
  {
    link: 'https://www.giojuliao.com/investor_agent',
    img: investorAgent,
    name: 'Investment Advisor AI Agent',
  },
  {
    link: 'https://www.giojuliao.com/shopify_agent',
    img: shopifyAgent,
    name: 'Shopify AI Agent',
  },
  {
    link: 'https://www.giojuliao.com/shopping_agent',
    img: shoppingAgent,
    name: 'AI Shopping Agent',
  },
  {
    link: 'https://www.giojuliao.com/realestate_agent',
    img: realestate,
    name: 'Realtor Assistant AI Agent',
  },
  {
    link: 'https://www.giojuliao.com/hr_agent',
    img: hrAgent,
    name: 'HR Consultant AI Agent',
  },
  {
    link: 'https://www.giojuliao.com/sales_agent',
    img: salesAgent,
    name: 'Sales Agent',
  },
  {
    link: 'https://www.linkedin.com/in/giovanni-juliao/overlay/1635483595138/single-media-viewer/?profileId=ACoAAAJq5cMBzp-q4fXs6Wjr5Sp8NdfZO1Nzk0A',
    img: israel,
    name: 'Israel Innovation Experience',
  },
  {
    link: 'https://gjuliao.github.io/crossfitwod/',
    img: crossfitwod,
    name: 'Crossfit WOD Live Demo',
  },
  {
    link: 'https://bcert.me/bc/html/show-badge.html?b=qjvrmsmw',
    img: sb,
    name: 'View Scrum Certificate',
  },
  {
    link: 'https://www.credential.net/e108e8a2-b391-4593-a09f-9db4e0a0e5e2#gs.c89itx',
    img: microverse,
    name: 'View Full Stack Certificate',
  },
  {
    link: 'https://github.com/gjuliao/workshop',
    img: workshop_rails,
    name: 'Workshop Rails Bootstrap',
  },
  {
    link: 'https://github.com/gjuliao/Rails_Marketplace',
    img: railsMarketplace,
    name: 'Rails Marketplace',
  },
];
